!(function () {
    "use strict";
    customElements.get("quantity-counter") ||
        customElements.define(
            "quantity-counter",
            class extends HTMLElement {
                constructor() {
                    super();
                }
                connectedCallback() {
                    this.input = this.querySelector("input");
                    this.changeEvent = new Event("change", { bubbles: true });
                    this.buttonClickEvent = this.onButtonClick.bind(this);
                    this.onQuantityChangeEvent = this.onQuantityChange.bind(this);
                    this.input.addEventListener("change", this.onQuantityChangeEvent);
                    this.querySelectorAll("button").forEach((button) => 
                        button.addEventListener("click", this.buttonClickEvent)
                    );
                }
                onButtonClick(event) {
                    event.preventDefault();
                    const prevValue = this.input.value;
                    const button = event.target.closest("button");
                    if (button.name === "increase") {
                        this.input.stepUp(); 
                    } else if (button.name === "decrease") {
                        this.input.stepDown();
                    }
                    if (this.input.value === "") {
                        this.input.value = 0; 
                    }
                    if (prevValue !== this.input.value) {
                        this.input.dispatchEvent(this.changeEvent);
                    }
                }
                onQuantityChange() {
                    if (this.input.value === "") {
                        this.input.value = 0;
                    }
                    this.updateCart();
                }
                updateCart() {
                    if (this.input.value !== "") {
                        this.dispatchEvent(new CustomEvent("theme:cart:update", {
                            bubbles: true,
                            detail: {
                                id: this.input.dataset.id,
                                quantity: this.input.value
                            }
                        }));
                    }
                }
            }
        );
})();
